module.exports = __webpack_public_path__ + "static/media/22-6.ec35ca2a.mp3";